import { NextResponse } from "next/server"

import { createSupabaseAdminClient } from "@/lib/supabase/admin"
import { createSupabaseServerClient } from "@/lib/supabase/server"

type CommentPayload = {
  recipeId: string
  authorName: string
  text: string
  parentId?: string | null
}

export async function POST(request: Request) {
  try {
    const body = (await request.json()) as Partial<CommentPayload>

    const payload: CommentPayload = {
      recipeId: body.recipeId?.trim() ?? "",
      authorName: body.authorName?.trim() ?? "",
      text: body.text?.trim() ?? "",
      parentId: body.parentId ?? null,
    }

    const errors: Partial<Record<"recipeId" | "authorName" | "text", string>> = {}

    if (payload.recipeId.length === 0) {
      errors.recipeId = "Не передано recipeId."
    }

    if (payload.authorName.length < 2) {
      errors.authorName = "Вкажіть ім’я довжиною щонайменше 2 символи."
    }

    if (payload.text.length < 5) {
      errors.text = "Коментар має містити щонайменше 5 символів."
    }

    if (Object.keys(errors).length > 0) {
      return NextResponse.json(
        { ok: false, message: "Помилка валідації.", errors },
        { status: 400 }
      )
    }

    const supabaseServer = await createSupabaseServerClient()
    const {
      data: { user },
    } = await supabaseServer.auth.getUser()

    const supabase = createSupabaseAdminClient()

    const { data, error } = await supabase
      .from("recipe_comments")
      .insert({
        user_id: user?.id ?? null,
        recipe_id: payload.recipeId,
        parent_id: payload.parentId,
        author_name: payload.authorName,
        text: payload.text,
        status: "pending",
      })
      .select(
        "id, user_id, recipe_id, parent_id, author_name, text, status, created_at"
      )
      .single()

    if (error) {
      return NextResponse.json(
        { ok: false, message: error.message },
        { status: 500 }
      )
    }

    return NextResponse.json({
      ok: true,
      message: "Коментар збережено і передано на модерацію.",
      data: {
        id: data.id,
        recipeId: data.recipe_id,
        parentId: data.parent_id,
        authorName: data.author_name,
        text: data.text,
        status: data.status,
        createdAt: data.created_at,
      },
    })
  } catch {
    return NextResponse.json(
      { ok: false, message: "Не вдалося обробити коментар." },
      { status: 500 }
    )
  }
}